import React, { useState } from 'react';
import './RoomsList.css';
import { FaShower, FaExpand, FaChessBoard, FaInternetExplorer, FaClock, FaChair } from 'react-icons/fa';
import { MdIron } from "react-icons/md";
import { CgSmartHomeRefrigerator } from "react-icons/cg";
// Example imports for images
import roomImage1 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage2 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage3 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage4 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage5 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage6 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage7 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage8 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage9 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage10 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage11 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage12 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage13 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage14 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage15 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage16 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage17 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage18 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage19 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage20 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage21 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage22 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage23 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage24 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage25 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage26 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage27 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage28 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage29 from '../assets/Roomslist/DSC_6678.JPG';
import roomImage30 from '../assets/Roomslist/DSC_6678.JPG';

// Data for the room cards
const cardsData = [
    {
        image: roomImage1,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage2,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage3,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage4,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage5,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage6,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage7,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage8,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage9,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage10,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage11,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage12,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage13,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage14,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage15,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage16,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage17,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage18,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage19,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage20,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage21,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage22,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage23,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage24,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage25,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage26,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage27,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage28,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage29,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
    {
        image: roomImage30,
        title: 'Triple Room – Full Board',
        price: '$121.00 PER NIGHT',
        link: '/room-details', // Link to the webpage
        icons: [
            { icon: <FaShower />, description: 'Shower' },
            { icon: <FaExpand />, description: 'Expand' },
            { icon: <FaChessBoard />, description: 'Chess' },
            { icon: <MdIron />, description: 'Iron' },
            { icon: <FaInternetExplorer />, description: 'Internet' },
            { icon: <CgSmartHomeRefrigerator />, description: 'Refrigerator' },
            { icon: <FaClock />, description: 'Clock' },
            { icon: <FaChair />, description: 'Chair' }
        ]
    },
];

function Card({ image, title, price, link, icons }) {
    return (
        <div className="card">
            <img src={image} alt={title} className="card-image" />
            <div className="card-content">
                <h3 className="card-title">{title}</h3>
                <p className="card-subtitle">{title}</p>
                <p className="card-price">{price}</p>
                <div className="card-icons">
                    {icons.map((icon, index) => (
                        <div className="icon-container" key={index} title={icon.description}>
                            {icon.icon}
                        </div>
                    ))}
                </div>
                <a href={link} className="card-link">More Details</a>
            </div>
        </div>
    );
}

function RoomsList() {
    const [currentPage, setCurrentPage] = useState(1);
    const cardsPerPage = 10;
    const totalPages = Math.ceil(cardsData.length / cardsPerPage);

    const handleClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const indexOfLastCard = currentPage * cardsPerPage;
    const indexOfFirstCard = indexOfLastCard - cardsPerPage;
    const currentCards = cardsData.slice(indexOfFirstCard, indexOfLastCard);

    return (
        <div className="rooms-list">
            <div className="cards-section">
                {currentCards.map((card, index) => (
                    <Card key={index} {...card} />
                ))}
            </div>
            <div className="pagination">
                <button onClick={handlePreviousClick} disabled={currentPage === 1}>Previous</button>
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index + 1}
                        onClick={() => handleClick(index + 1)}
                        className={currentPage === index + 1 ? 'active' : ''}
                    >
                        {index + 1}
                    </button>
                ))}
                <button onClick={handleNextClick} disabled={currentPage === totalPages}>Next</button>
            </div>
        </div>
    );
}

export default RoomsList;